import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377b23cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "h-0.5 border-t-0 bg-gray-500 first:hidden" }, null, -1))
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "h-[calc(100vh-146px)] flex-1 flex justify-center space-y-6 overflow-auto" }
const _hoisted_4 = { class: "w-full max-w-[700px] py-6 flex flex-col space-y-6" }
const _hoisted_5 = {
  id: "form_top",
  class: "relative p-6 bg-white border rounded border-neutral-300 scroll-to"
}
const _hoisted_6 = { class: "grid grid-cols-6 gap-6 mt-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "font-semibold text-neutral-900" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-500" }, "Relevant data and other details", -1))
const _hoisted_11 = { class: "w-full mt-6" }
const _hoisted_12 = { class: "flex items-center justify-end w-full" }
const _hoisted_13 = { class: "flex justify-end flex-1" }
const _hoisted_14 = { class: "w-6 h-6 cursor-grab" }
const _hoisted_15 = { class: "flex justify-end flex-1 space-x-2" }
const _hoisted_16 = {
  key: 0,
  class: "relative group"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute top-6 right-0 z-10 rounded bg-gray-500 p-3 text-white text-xs min-w-[220px] group-hover:block hidden" }, [
  /*#__PURE__*/_createElementVNode("p", null, "This field is connected to a report or other parts of the system. Removing this field or any of it's content is not allowed.")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2 spacer" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "h-[calc(100vh-146px)] w-[400px] p-6 bg-white flex flex-col relative"
}
const _hoisted_20 = { class: "flex-1 overflow-auto" }
const _hoisted_21 = {
  key: 1,
  class: "h-[calc(100vh-146px)] w-[400px] p-6 bg-white flex flex-col relative"
}
const _hoisted_22 = { class: "pb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-neutral-900" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Field Types")
], -1))
const _hoisted_24 = { class: "flex mt-5 overflow-hidden border rounded border-neutral-100" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "All Fields", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Fields w/ Sub-form", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "flex-1 overflow-auto" }
const _hoisted_30 = { class: "grid w-full grid-cols-2 gap-5" }
const _hoisted_31 = { class: "flex space-x-6" }
const _hoisted_32 = { class: "w-1/2" }
const _hoisted_33 = { class: "w-1/2" }

import { ref, type PropType, computed } from "vue";
import { IonSkeletonText } from '@ionic/vue';

import SectionTitle from "@/components/partials/SectionTitle.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";

import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SortIcon from "@/components/icons/sortIcon.vue";

import FormSection from "@/views/settings/InterventionTypes/FormSection.vue";

import ContentModal from "./Components/ContentModal.vue";

import draggable from "vuedraggable";
import { PencilSquareIcon, TrashIcon, InformationCircleIcon } from "@heroicons/vue/24/outline";

import { 
    FieldInterface,
    FormInterface,
} from "@/interfaces/pages/InterventionForm/InterventionFormInterface";


import InputType from "./Modals/InputType.vue";

import FieldType from "@/views/settings/InterventionTypes/Components/Inputs/FieldType.vue";
import { FormFieldType } from "@/views/enums/FormFieldType";
import InterventionTypeService from "@/classes/Settings/InterventionTypeService.ts"



export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object as PropType<FormInterface>,
        required: true,
        default: () => ({ attachment: '' })
    },
    formFieldTypes: {
        type: Object as PropType<FieldInterface>,
        required: true,
        default: () => ({ attachment: '' })
    },
    existingDropdowns: {
        type: Object,
        required: true,
    },
    errors: {
        type: Object,
        required: true,
    },
},
  emits: ['open', 'close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;


const selected = ref<boolean>(false);
const selectedField = ref<any>({});

const showConfirmation = ref<boolean>(false)

const changeMeOptions = [
	{ id: '1', label: 'Change', value: 'Change'},
	{ id: '2', label: 'Me', value: 'Me'},
]

const showSubFrom = ref<boolean>(false);
const showSubfromModal = ref<boolean>(false);
const showFieldForm= ref<boolean>(false);
const editingField = ref<boolean>(false);

const subFrom = ref<FormInterface|null>(null);
const editMode = ref<number>(1);
const selectedRemove = ref<number|null>(null);
const selectedRemoveFieldId = ref(null);

const dragging = ref(false);

const checkMove = (e) => {
    console.log("Future index: " + e.draggedContext.futureIndex);
};

const openFieldForm = (item:FieldInterface) => {
    console.log(item);
    editingField.value = true;
    showFieldForm.value = false;
    selectedField.value = item;
    emit('open')
    setTimeout(() => {
        showFieldForm.value = true;
    }, 300);
};

const showRemoveFieldForm = (item:FieldInterface) => {
    selectedRemove.value = form.value.fields.indexOf(item)
    showConfirmation.value = true;
    selectedRemoveFieldId.value = item?.id || null;
};

const removeFieldForm = () => {
    showConfirmation.value = false;

    form.value.fields.splice(selectedRemove.value, 1);

    if (selectedRemoveFieldId.value) {
        InterventionTypeService.removeField(selectedRemoveFieldId.value)
    }
};


const loadForm = (form:FormInterface):void => {
    showSubFrom.value = false;
    subFrom.value = form
    setTimeout(() => {
        showSubFrom.value = true;
        // console.log(form.order);
        // const element = document.getElementById(form.order)
        // console.log(element);
        // element.scrollIntoView({
        //     behavior: "smooth",
        //     inline: "start",
        // });

    }, 300);
};


const close = () => {
    editingField.value = false;
    showFieldForm.value = false;
    selectedField.value = null;
    emit('close')
};

const getDefaultForm = (field:FieldInterface):any => {
    return {
        input_type: field.id,
        has_options: field?.has_options ?? false,
        has_sub_form: field?.has_sub_form ?? false,
        is_half_width: true,
        is_required: false,
        label: null,
        options: null,
        order: null,
    }
};

const form = ref<object>(props.form);

const dragOptions = computed(() => ({
    animation: 200,
}));


return (_ctx: any,_cache: any) => {
  const _component_button_component = _resolveComponent("button-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      id: form.value.label + form.value.id,
      class: "flex items-start scroll-to"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(SectionTitle, {
              fontSmall: "",
              title: form.value.label,
              description: "Relevant data and other details",
              cstmTitleClass: "!text-base"
            }, null, 8, ["title"]),
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Intervention Type Name",
                  placeholder: "Intervention Type Name",
                  name: "intervention_type_name",
                  id: "intervention_type_name",
                  modelValue: form.value.label,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.label) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", {
            id: 'form_' + form.value.id,
            class: _normalizeClass(["relative p-6 bg-white border rounded border-neutral-300 scroll-to", editMode.value == form.value.id ? 'shadow-[-5px_0px_0px_0px_rgba(0,113,250,1)]' : '']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (editMode.value = form.value.id ))
          }, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(form.value.label) + " Form Builder ", 1),
            _hoisted_10,
            _createElementVNode("form", _hoisted_11, [
              _createVNode(_unref(draggable), _mergeProps({
                list: form.value.fields,
                "item-key": "label",
                class: "grid grid-cols-6 gap-6",
                handle: ".handle",
                move: checkMove
              }, dragOptions.value, {
                onStart: _cache[1] || (_cache[1] = ($event: any) => (dragging.value = true)),
                onEnd: _cache[2] || (_cache[2] = ($event: any) => (dragging.value = false)),
                "component-data": {
                                tag: 'ul',
                                type: 'transition-group',
                                name: !dragging.value ? 'flip-list' : null
                            }
              }), {
                item: _withCtx(({ element }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["col-span-3 px-6 pt-3 pb-6 bg-white border rounded border-neutral-300", [ 
                                    element.is_half_width && element.input_type != _unref(FormFieldType).DROPDOWN_EXISTING  ? 'col-span-3' : 'col-span-6',
                                    selectedField.value == element ? 'bg-blue-600 border-2 border-blue-600' : 'bg-white border-neutral-300',
                                    ]])
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", _hoisted_14, [
                          _createVNode(SortIcon, { class: "object-contain w-6 h-6 handle" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_unref(PencilSquareIcon), {
                          class: "w-6 h-6 transition cursor-pointer text-neutral-900 hover:text-secondary-600",
                          onClick: ($event: any) => (openFieldForm(element))
                        }, null, 8, ["onClick"]),
                        (element.form_tag || element.report_code)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6 cursor-pointer text-primary-600" }),
                              _hoisted_17
                            ]))
                          : (_openBlock(), _createBlock(_unref(TrashIcon), {
                              key: 1,
                              class: "w-6 h-6 text-red-600 transition cursor-pointer hover:text-red-700",
                              onClick: ($event: any) => (showRemoveFieldForm(element))
                            }, null, 8, ["onClick"]))
                      ])
                    ]),
                    _createVNode(FieldType, {
                      field: element,
                      errors: __props.errors
                    }, null, 8, ["field", "errors"])
                  ], 2)
                ]),
                _: 1
              }, 16, ["list", "component-data"])
            ])
          ], 10, _hoisted_8),
          _hoisted_18,
          _createVNode(ConfirmationModal, {
            typeTwo: true,
            show: showConfirmation.value,
            onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
            onConfirm: _cache[5] || (_cache[5] = ($event: any) => (removeFieldForm())),
            "cancel-text": "Cancel",
            "action-text": "Confirm",
            title: "Removal Warning",
            content: "This field is connected to a sub-form. Removing this field will remove the child forms as well."
          }, null, 8, ["show"])
        ])
      ]),
      (editingField.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (!showFieldForm.value)
              ? (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                  key: 0,
                  animated: true,
                  style: {"width":"100%","height":"100%"}
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              (showFieldForm.value)
                ? (_openBlock(), _createBlock(InputType, {
                    key: 0,
                    show: showFieldForm.value,
                    form: form.value,
                    item: selectedField.value,
                    formField: selectedField.value,
                    fieldType: selectedField.value.input_type,
                    existingDropdowns: __props.existingDropdowns,
                    editMode: "",
                    onOpen: _cache[6] || (_cache[6] = ($event: any) => (_ctx.open())),
                    onClose: _cache[7] || (_cache[7] = () => close()),
                    "onLoad:form": _cache[8] || (_cache[8] = (form) => loadForm(form))
                  }, null, 8, ["show", "form", "item", "formField", "fieldType", "existingDropdowns"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex-1 py-3 text-center cursor-pointer", selected.value ? 'text-gray-500' : 'bg-primary-100 text-primary-500']),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (selected.value = false))
                }, _hoisted_26, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex-1 py-3 text-center cursor-pointer", selected.value ? 'bg-primary-100 text-primary-500' : 'text-gray-500']),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (selected.value = true))
                }, _hoisted_28, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formFieldTypes, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.id
                  }, [
                    (selected.value && item.has_sub_form)
                      ? (_openBlock(), _createBlock(InputType, {
                          key: 0,
                          form: form.value,
                          formField: getDefaultForm(item),
                          item: item,
                          fieldType: item.value,
                          "onLoad:form": _cache[11] || (_cache[11] = (form) => loadForm(form)),
                          onOpen: _cache[12] || (_cache[12] = ($event: any) => (_ctx.open())),
                          onClose: _cache[13] || (_cache[13] = () => close()),
                          existingDropdowns: __props.existingDropdowns
                        }, null, 8, ["form", "formField", "item", "fieldType", "existingDropdowns"]))
                      : _createCommentVNode("", true),
                    (!selected.value)
                      ? (_openBlock(), _createBlock(InputType, {
                          key: 1,
                          form: form.value,
                          formField: getDefaultForm(item),
                          item: item,
                          fieldType: item.value,
                          "onLoad:form": _cache[14] || (_cache[14] = (form) => loadForm(form)),
                          onOpen: _cache[15] || (_cache[15] = ($event: any) => (_ctx.open())),
                          onClose: _cache[16] || (_cache[16] = () => close()),
                          existingDropdowns: __props.existingDropdowns
                        }, null, 8, ["form", "formField", "item", "fieldType", "existingDropdowns"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ]))
    ], 8, _hoisted_2),
    _createVNode(ContentModal, {
      show: showSubfromModal.value,
      title: "Add Conditional Form Trigger"
    }, {
      button: _withCtx(() => [
        _createVNode(_component_button_component, {
          btnWidth: "quinary",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (showSubfromModal.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cancel ")
          ]),
          _: 1
        }),
        _createVNode(_component_button_component, { customClass: "primary" }, {
          default: _withCtx(() => [
            _createTextVNode(" Submit ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(MultiSelect, {
              options: changeMeOptions,
              label: "Parent Field",
              id: "parent_field",
              name: "parent_field",
              placeholder: "Select..",
              searchable: ""
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(MultiSelect, {
              options: changeMeOptions,
              label: "Option Value",
              id: "option_value",
              name: "option_value",
              placeholder: "Select..",
              searchable: ""
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (showSubFrom.value && subFrom.value != null)
      ? (_openBlock(), _createBlock(FormSection, {
          key: 0,
          form: subFrom.value,
          formFieldTypes: __props.formFieldTypes
        }, null, 8, ["form", "formFieldTypes"]))
      : _createCommentVNode("", true),
    (!showSubFrom.value && subFrom.value != null)
      ? (_openBlock(), _createBlock(_unref(IonSkeletonText), {
          key: 1,
          animated: true,
          style: {"width":"100%","height":"100%"}
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})